import * as React from "react";
import useDelayedEffect from "../../hooks/useDelayedEffect";
import { CircularProgress } from "@material-ui/core";

interface ILoading {
    immediate?: boolean;
    size?: string;
    inline?: boolean;
    delay?: number;
}

const Loading: React.FC<ILoading> = ({
    immediate = false,
    // inline = false,
    delay = 128,
    children
}) => {
    //    const classes = useStyles({});
    const [show, setShow] = React.useState(immediate);

    useDelayedEffect(() => setShow(true), delay, []);

    if (!show) {
        return <div />;
    }

    // return (
    //     <div className={inline ? classes.loadingInline : classes.loading}>
    //         {children}
    //     </div>
    // );

    return <CircularProgress color="inherit">{children}</CircularProgress>;
};

export default Loading;
